import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { rm } from "@/lib/format";
import { useDashboardCtx } from "@/context/DashboardContext";
import { Button } from "@/components/ui/button";
import { Loader2, Eye, Building2 } from "lucide-react";

const PLAN_COLOR = {
  "Business AI": "bg-primary/15 text-primary",
  "Pro": "bg-accent/15 text-accent",
  "Growth": "bg-chart-3/15 text-chart-3",
  "Agency": "bg-purple-500/15 text-purple-400",
  "Starter": "bg-secondary text-muted-foreground",
};

export default function Customers() {
  const { enterCustomerView } = useDashboardCtx();
  const [customers, setCustomers] = useState(null);

  useEffect(() => { api.get("/customers").then((r) => setCustomers(r.data)).catch(() => setCustomers([])); }, []);

  if (!customers) return <div className="flex justify-center py-20"><Loader2 className="w-6 h-6 animate-spin text-primary" /></div>;

  return (
    <div className="space-y-4 animate-float-up" data-testid="customers-panel">
      <p className="text-sm text-muted-foreground">As an Admin you can view each customer's command centre in read-only mode.</p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {customers.map((c) => (
          <div key={c.id} data-testid={`customer-card-${c.id}`} className="bg-card border border-border rounded-2xl p-5 hover:border-primary/40 transition-colors duration-200">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-11 h-11 rounded-xl bg-primary/15 flex items-center justify-center font-display font-bold text-primary">{c.initial}</div>
              <div className="min-w-0">
                <p className="font-display font-semibold truncate">{c.name}</p>
                <p className="text-xs text-muted-foreground flex items-center gap-1"><Building2 className="w-3 h-3" />{c.industry}</p>
              </div>
            </div>
            <span className={`text-[10px] font-mono font-bold px-2.5 py-1 rounded-full ${PLAN_COLOR[c.plan] || "bg-secondary text-muted-foreground"}`}>{c.plan}</span>
            <div className="grid grid-cols-2 gap-2 mt-4 text-sm">
              <div><p className="text-[11px] text-muted-foreground">Ad Spend</p><p className="font-mono">{rm(c.spend)}</p></div>
              <div><p className="text-[11px] text-muted-foreground">Revenue</p><p className="font-mono text-accent">{rm(c.revenue)}</p></div>
              <div><p className="text-[11px] text-muted-foreground">Leads</p><p className="font-mono">{c.leads}</p></div>
              <div><p className="text-[11px] text-muted-foreground">ROAS</p><p className="font-mono text-primary">{c.roas}x</p></div>
            </div>
            <Button data-testid={`customer-view-${c.id}`} onClick={() => enterCustomerView(c)} className="w-full mt-5 bg-primary hover:bg-primary/90 text-primary-foreground rounded-xl font-semibold">
              <Eye className="w-4 h-4 mr-1" /> View Dashboard
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
}
